export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6200.bea80f29.jpg";